import { missionPEField } from '../../../../utils/constants'

export const initialState = (page_element = {}) => ({
  id: page_element.id,
  answer_text: '',
})

export const answerUpdate = (state = initialState(), payload) => ({
  ...state,
  answer_text: payload[missionPEField(state)],
})



// WEBPACK FOOTER //
// ./src/reducers/Missions/Answers/Form/input.jsx